import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { IdOrientation } from "../../constants/IdOrientation";
import { utilBuildings } from "../../utils/utilBuildings";
import { BF2CreateAsset, BF2CreateHitArea, BF2IsPathExpansion, BF2PositionSurroundingPiece, } from "../BF2BuildingGraphicsUtils";
var Container = PIXI.Container;
var FenceNudgeOnMap = 0.5;
export var GetFencePieceIso = function (data, orientation, baseSetup) {
    // Hack: data.proto contains position for expansion on map
    var pos = { x: data.proto.posX || 0, y: data.proto.posY || 0 };
    var isPath = BF2IsPathExpansion(pos, baseSetup) && orientation === IdOrientation.Down;
    var assetKey = isPath ? "Gate" : "Piece";
    var level = utilBuildings.getVisualLevel(data);
    var config = artConfigBuildings["fence" + assetKey + level];
    var fenceConfig = config.assets[0];
    var fence = BF2CreateAsset(fenceConfig, false);
    var container = new Container();
    container.name = "Fence " + assetKey + " [" + orientation + "]";
    container.addChild(fence);
    BF2PositionSurroundingPiece(container, orientation, FenceNudgeOnMap, baseSetup);
    container.hitArea = BF2CreateHitArea(config.colliders, fence.position, container, orientation === IdOrientation.Left || orientation === IdOrientation.Right);
    // We currently only handle clicks on gate only
    container.interactive = isPath;
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/fence/GetFencePieceIso.ts
// module id = 2216
// module chunks = 3